// #region Imports
import { defineComponent, reactive } from "vue";
import ValidationManager from "../../../../services/validation/index";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-form',
    props: {
        formName: {
            type: String,
            required: false,
            default: ''
        },
        xsfrToken: {
            type: String,
            required: false,
            default: ''
        },
        submitAction: {
            type: Object,
            required: false,
            default: {}
        },
        successAction: {
            type: Object,
            required: false,
            default: {}
        },
        cancelAction: {
            type: Object,
            required: false,
            default: {}
        },
        dataObject: {
            type: Object,
            required: false,
            default() {
                return reactive({});
            }
        }
    },
    data: () => ({
        realForm: {},
    }),
    beforeMount() {
        // #region Form
        this.$form = new ValidationManager(this);
        // #endregion
        // #region Events
        this.$form.eventBus.on('submit', (e) => {
            this.submitForm(e.event, e.sender);
        });
        this.$form.eventBus.on('cancel', (e) => {
            this.cancelForm(e.event);
        });
        // #endregion            
        if (this.dataObject) {
            this.$form?.setData(this.dataObject);
        }
        else {
            this.$form?.setData(reactive({}));
        }
    },
    watch: {
        'dataObject': function (value) {
            if (this.dataObject && this.dataObject.__ob__) {
                this.$form?.setData(this.dataObject);
            }
            else if (this.dataObject) {
                this.$form?.setData(this.dataObject);
            }
            else {
                this.$form?.setData(reactive({}));
            }
        },
    },
    methods: {
        submitForm(event, button) {
            // #region Check
            event.preventDefault();
            // #endregion
            // #region Validate
            if (!this.$form.validate()) {
                return;
            }
            if (utils.isNullOrEmpty(this.submitAction)) {
                return;
            }
            // #endregion
            // #region Loading
            if (button) {
                button.isLoadingManually = true;
            }
            // #endregion
            // #region Content
            //Default
            let tData = this.$form?.data;
            let tConfig = {};
            //Form
            if (this.hasFiles(tData)) {
                //Config
                tConfig = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'multipart/form-data',
                    }
                };
                //FormData
                tData = this.GetFormDataWithFiles(tData);
            }
            // #endregion
            //#region Run
            var tApi = host.api;
            {
                if (this.submitAction.mode === "views") {
                    tApi = host.views;
                }
            }
            tApi.post(this.submitAction.path, tData, tConfig)
                .then(e => {
                // #region Loading
                if (button) {
                    button.isLoadingManually = false;
                }
                // #endregion
                // #region Special
                let tAction = this.successAction;
                //Override by Result
                if (e.data.action) {
                    tAction = e.data.action;
                }
                // #endregion
                // #region Sucess
                if (utils.isNullOrEmpty(tAction)) {
                    return;
                }
                if (tAction.mode === "to") {
                    this.$router.push({ path: tAction.path });
                }
                else if (tAction.mode === "message") {
                    host.notification.showToast(tAction.message, "success");
                }
                else if (tAction.mode === "login") {
                    host.login.loginByUsername(this.$form?.data.eMail, this.$form?.data.password).then((e) => {
                        if (!e.isSucceded && e.errorCode === "account_activate") {
                            this.$router.push({ name: "login-activate", params: { userId: e.customData.userId } });
                        }
                        else if (!e.isSucceded) {
                            this.$form.setError("$", e.errorMessage);
                        }
                        else {
                            this.$router.push("/");
                        }
                    });
                }
                // #endregion
            })
                .catch(e => {
                // #region Loading
                if (button && button.isLoadingManually) {
                    button.isLoadingManually = false;
                }
                // #endregion
                // #region Error
                if (e.response.data.errors) {
                    //Append
                    Object.keys(e.response.data.errors).forEach((k) => {
                        if (utils.isArray(e.response.data.errors[k])) {
                            let tCounter = 0;
                            e.response.data.errors[k].forEach((e) => {
                                this.$form.setError("$." + k + (tCounter === 0 ? '' : '.' + tCounter), e);
                                tCounter++;
                            });
                        }
                        else {
                            this.$form.setError("$." + k, e.response.data.errors[k]);
                        }
                    });
                }
                else if (e.response.data.error_description) {
                    this.$form.setError("$", e.response.data.error_description);
                }
                else if (e.response.data.error) {
                    this.$form.setError("$", e.response.data.error);
                }
                else {
                    this.$form.setError("$", "Unbekannter Fehler");
                }
                // #endregion
            });
            // #endregion
        },
        cancelForm(event) {
            // #region Prevent
            event.preventDefault();
            // #endregion
            // #region Check
            if (utils.isNullOrEmpty(this.cancelAction)) {
                return;
            }
            // #endregion
            // #region Run
            if (this.cancelAction.mode == "to") {
                this.$router.push({ path: this.cancelAction.path });
            }
            else if (this.cancelAction.mode == "message") {
                host.notification.showToast(this.cancelAction.message, "warning");
            }
            // #endregion
        },
        hasFiles(source) {
            for (let a of Object.keys(source)) {
                // #region Run
                if (source[a] instanceof File) {
                    return true;
                }
                if (Array.isArray(source[a])) {
                    //Run
                    let tArray = source[a];
                    if (tArray.length > 0) {
                        if (tArray[0] instanceof File) {
                            return true;
                        }
                    }
                }
                // #endregion
            }
        },
        GetFormDataWithFiles(source) {
            // #region Vars
            var formData = new FormData();
            // #endregion
            // #region Set
            for (let a of Object.keys(source)) {
                // #region Run
                if (source[a] instanceof File) {
                    formData.append(a, source[a]);
                }
                else if (Array.isArray(source[a])) {
                    //Run
                    let tArray = source[a];
                    if (tArray.length > 0) {
                        if (tArray[0] instanceof File) {
                            tArray.forEach(e => {
                                formData.append(a, e);
                            });
                        }
                    }
                }
                // #endregion
            }
            // #endregion                
            // #region Content
            formData.append("document", JSON.stringify(this.$form?.data));
            // #endregion
            return formData;
        }
    }
});
// #endregion
